import "@/helpers/turbo"
import { application } from "../helpers/stimulus"

import { initSearch } from "@/components/elm_search"
import { setupSearchBar } from "@/components/search_bar"

import CarouselController from "../controllers/carousel_controller"
import DisclosureItemController from "../controllers/disclosure_item_controller"
import ModalTriggerController from "../controllers/modal_trigger_controller"

import FiltersFormController from "../controllers/search/filters_form_controller"
import FiltersModalController from "../controllers/search/filters_modal_controller"
import MapMarkerCarouselController from "../controllers/search/map_marker_carousel_controller"
import PriceFilterController from "../controllers/search/price_filter_controller"
import ProgressBarController from "../controllers/search/progress_bar_controller"
import SearchMapController from "../controllers/search/search_map_controller"
import SearchResultsController from "../controllers/search/search_results_controller"

import { ENTRY, prefetchEntry } from "@/helpers/prefetch"
import { addTurboFiltersHandlers } from "@/helpers/search"
import toggleContent from "@/helpers/toggle_content"
import { trackVisit } from "@/helpers/visit_tracker"

const NEW_SEARCH_BAR = document.body.getAttribute("data-new-search-bar") === "true"
const NEW_SEARCH_PAGE = document.body.getAttribute("data-new-search-page") === "true"

const prefetchVenues = (): void => {
  document.addEventListener("DOMContentLoaded", () => prefetchEntry(ENTRY.VENUES))
}

const setupStimulus = (): void => {
  application.register("carousel", CarouselController)
  application.register("filters-form", FiltersFormController)
  application.register("filters-modal", FiltersModalController)
  application.register("filters-modal-trigger", ModalTriggerController)
  application.register("map-marker-carousel", MapMarkerCarouselController)
  application.register("price-filter", PriceFilterController)
  application.register("progress-bar", ProgressBarController)
  application.register("search-map", SearchMapController)
  application.register("search-results", SearchResultsController)

  if (NEW_SEARCH_PAGE) {
    application.register("disclosure-item", DisclosureItemController)
  }
}

if (NEW_SEARCH_BAR) {
  setupSearchBar()
  addTurboFiltersHandlers()
} else {
  initSearch()
}

setupStimulus()
toggleContent(document)
prefetchVenues()

const RECENT_SEARCHES_HOMEPAGE =
  document.body.getAttribute("data-recent-searches-homepage") === "true"

if (RECENT_SEARCHES_HOMEPAGE) {
  void trackVisit("/search_visit")
}
